import { inject, Injector, provideAppInitializer } from '@angular/core';
import { AppInjectorService } from '../services/app-injector/app-injector.service';

export const AppInjectorProvider = provideAppInitializer(() => {
  const injector = inject(Injector);
  AppInjectorService.setInjector(injector);
  return;
});
